import { useState, useEffect } from 'react'
import { supabase, storage } from '../../lib/supabase'
import { formatLocalDate } from '../../utils/dateUtils'

export default function Marcas() {
  const [marcas, setMarcas] = useState([])
  const [categorias, setCategorias] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [showComentariosModal, setShowComentariosModal] = useState(false)
  const [selectedMarca, setSelectedMarca] = useState(null)
  const [comentariosPendientes, setComentariosPendientes] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')
  const [selectedEstado, setSelectedEstado] = useState('')

  useEffect(() => {
    fetchCategorias()
    fetchMarcas()
  }, [])

  const fetchCategorias = async () => {
    const { data } = await supabase
      .from('categorias')
      .select('*')
      .eq('tipo', 'Locatario')
      .order('nombre')
    setCategorias(data || [])
  }

  const fetchMarcas = async () => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('tiendas')
        .select(`
          *,
          categorias(nombre)
        `)
        .order('nombre')

      if (error) throw error
      setMarcas(data || [])
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchComentarios = async (tiendaId) => {
    const { data } = await supabase
      .from('comentarios')
      .select('*')
      .eq('tienda_id', tiendaId)
      .eq('publicado', false)
      .order('created_at', { ascending: false })
    setComentariosPendientes(data || [])
  }

  const handleDelete = async (id) => {
    if (!confirm('¿Estás seguro de eliminar esta marca?')) return
    
    const { error } = await supabase
      .from('tiendas')
      .delete()
      .eq('id', id)
    
    if (!error) {
      fetchMarcas()
      alert('Marca eliminada exitosamente')
    }
  }

  const togglePublicado = async (id, currentState) => {
    const { error } = await supabase
      .from('tiendas')
      .update({ publicado: !currentState })
      .eq('id', id)

    if (!error) {
      fetchMarcas()
    }
  }

  const handleApproveComentario = async (comentarioId, aprobar) => {
    const { error } = await supabase
      .from('comentarios')
      .update({ publicado: aprobar })
      .eq('id', comentarioId)

    if (!error) {
      fetchComentarios(selectedMarca.id)
      fetchMarcas()
      alert(aprobar ? 'Comentario aprobado' : 'Comentario rechazado')
    }
  }

  const openComentariosModal = async (marca) => {
    setSelectedMarca(marca)
    await fetchComentarios(marca.id)
    setShowComentariosModal(true)
  }

  const filteredMarcas = marcas.filter(marca => {
    const matchesSearch = marca.nombre.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesCategory = !selectedCategory || marca.categoria_id === selectedCategory
    const matchesEstado = !selectedEstado || (selectedEstado === 'publicado' ? marca.publicado : !marca.publicado)
    return matchesSearch && matchesCategory && matchesEstado
  })

  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1.5rem'
      }}>
        <h1 style={{
          fontSize: 'var(--h1)',
          fontWeight: '700',
          fontFamily: 'var(--font-display)',
          color: 'var(--textPrimary)'
        }}>TIENDAS</h1>
        <button
          onClick={() => {
            setSelectedMarca(null)
            setShowModal(true)
          }}
          style={{
            padding: '0.75rem 1.5rem',
            background: 'var(--ctaBg)',
            color: 'var(--ctaText)',
            border: 'none',
            borderRadius: 'var(--radius-md)',
            fontSize: 'var(--body)',
            fontWeight: '600',
            fontFamily: 'var(--font-ui)',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'var(--accentPurpleDark)'
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = 'none'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'var(--ctaBg)'
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = 'none'
          }}
        >
          + Nueva Marca
        </button>
      </div>

      {/* Filtros */}
      <div style={{
        background: 'var(--surface)',
        padding: '1.5rem',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'none',
        border: 'var(--card-border)',
        marginBottom: '1.5rem'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem'
        }}>
          <input
            type="text"
            placeholder="Buscar marca..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          />
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
              cursor: 'pointer'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <option value="">Todas las categorías</option>
            {categorias.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.nombre}</option>
            ))}
          </select>
          <select
            value={selectedEstado}
            onChange={(e) => setSelectedEstado(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
              cursor: 'pointer'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <option value="">Todos los estados</option>
            <option value="publicado">Publicados</option>
            <option value="borrador">Borradores</option>
          </select>
        </div>
      </div>

      {/* Tabla de Marcas */}
      <div style={{
        background: 'var(--surface)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'none',
        border: 'var(--card-border)',
        overflow: 'hidden'
      }}>
        {loading ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              border: '3px solid var(--background)',
              borderTop: '3px solid var(--accentPurple)',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 1rem'
            }}></div>
            <p style={{
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textMuted)'
            }}>Cargando...</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse'
            }}>
              <thead style={{
                background: 'var(--background)'
              }}>
                <tr>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Estado</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Logo</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Nombre</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Categoría</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Local</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Puntuación</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Acciones</th>
                </tr>
              </thead>
              <tbody style={{
                background: 'var(--surface)'
              }}>
                {filteredMarcas.length === 0 ? (
                  <tr>
                    <td colSpan="7" style={{
                      padding: '3rem 1.5rem',
                      textAlign: 'center',
                      fontSize: 'var(--body)',
                      fontFamily: 'var(--font-ui)',
                      color: 'var(--textMuted)'
                    }}>
                      No se encontraron tiendas
                    </td>
                  </tr>
                ) : (
                  filteredMarcas.map((marca) => (
                    <tr key={marca.id} style={{
                      borderTop: '1px solid var(--mutedStroke)',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = 'var(--background)'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '1rem 1.5rem' }}>
                        <button
                          onClick={() => togglePublicado(marca.id, marca.publicado)}
                          style={{
                            padding: '0.5rem 0.75rem',
                            borderRadius: 'var(--radius-pill)',
                            fontSize: 'var(--small)',
                            fontWeight: '600',
                            fontFamily: 'var(--font-ui)',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            background: marca.publicado ? '#D1FAE5' : '#F3F4F6',
                            color: marca.publicado ? '#065F46' : '#374151'
                          }}
                        >
                          {marca.publicado ? '✓ Publicado' : '📝 Borrador'}
                        </button>
                      </td>
                      <td style={{ padding: '1rem 1.5rem' }}>
                        {marca.logo_url ? (
                          <img src={marca.logo_url} alt={marca.nombre} style={{
                            height: '48px',
                            width: '48px',
                            objectFit: 'contain'
                          }} />
                        ) : (
                          <div style={{
                            height: '48px',
                            width: '48px',
                            background: 'var(--background)',
                            borderRadius: 'var(--radius-md)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 'var(--small)',
                            fontFamily: 'var(--font-ui)',
                            color: 'var(--textMuted)'
                          }}>
                            Sin logo
                          </div>
                        )}
                      </td>
                      <td style={{
                        padding: '1rem 1.5rem',
                        fontWeight: '500',
                        fontFamily: 'var(--font-ui)',
                        color: 'var(--textPrimary)'
                      }}>{marca.nombre}</td>
                      <td style={{
                        padding: '1rem 1.5rem',
                        fontSize: 'var(--small)',
                        fontFamily: 'var(--font-ui)',
                        color: 'var(--textPrimary)'
                      }}>{marca.categorias?.nombre || '-'}</td>
                      <td style={{
                        padding: '1rem 1.5rem',
                        fontSize: 'var(--small)',
                        fontFamily: 'var(--font-ui)',
                        color: 'var(--textPrimary)'
                      }}>{marca.nro_local || '-'} {marca.piso_planta}</td>
                      <td style={{ padding: '1rem 1.5rem' }}>
                        <span style={{ color: '#FBBF24', fontSize: '1.25rem' }}>
                          {'⭐'.repeat(Math.round(marca.puntuacion_promedio || 0))}
                        </span>
                        <span style={{
                          fontSize: 'var(--small)',
                          fontFamily: 'var(--font-ui)',
                          color: 'var(--textMuted)',
                          marginLeft: '0.25rem'
                        }}>
                          {marca.puntuacion_promedio ? marca.puntuacion_promedio.toFixed(1) : '0.0'}
                        </span>
                      </td>
                      <td style={{ padding: '1rem 1.5rem' }}>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <button
                            onClick={() => openComentariosModal(marca)}
                            style={{
                              background: 'none',
                              border: 'none',
                              fontSize: '1.25rem',
                              cursor: 'pointer',
                              padding: '0.25rem',
                              transition: 'transform 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}                            title="Revisar comentarios"
                          >
                            💬
                          </button>
                          <button
                            onClick={() => {
                              setSelectedMarca(marca)
                              setShowModal(true)
                            }}
                            style={{
                              background: 'none',
                              border: 'none',
                              fontSize: 'var(--small)',
                              fontFamily: 'var(--font-ui)',
                              color: 'var(--accentPurple)',
                              cursor: 'pointer',
                              padding: '0.25rem 0.5rem',
                              transition: 'opacity 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                          >
                            Editar
                          </button>
                          <button
                            onClick={() => handleDelete(marca.id)}
                            style={{
                              background: 'none',
                              border: 'none',
                              fontSize: 'var(--small)',
                              fontFamily: 'var(--font-ui)',
                              color: '#DC2626',
                              cursor: 'pointer',
                              padding: '0.25rem 0.5rem',
                              transition: 'opacity 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                          >
                            Eliminar
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal CRUD */}
      {showModal && (
        <MarcaFormModal
          marca={selectedMarca}
          categorias={categorias}
          onClose={() => {
            setShowModal(false)
            setSelectedMarca(null)
          }}
          onSuccess={() => {
            setShowModal(false)
            setSelectedMarca(null)
            fetchMarcas()
          }}
        />
      )}

      {/* Modal Comentarios */}
      {showComentariosModal && (
        <ComentariosModal
          marca={selectedMarca}
          comentarios={comentariosPendientes}
          onClose={() => setShowComentariosModal(false)}
          onApprove={handleApproveComentario}
        />
      )}
    </div>
  )
}

// Modal para crear/editar marca
function MarcaFormModal({ marca, categorias, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    nombre: marca?.nombre || '',
    descripcion: marca?.descripcion || '',
    categoria_id: marca?.categoria_id || '',
    telefono: marca?.telefono || '',
    email: marca?.email || '',
    whatsapp: marca?.whatsapp || '',
    nro_local: marca?.nro_local || '',
    piso_planta: marca?.piso_planta || '',
    logo_url: marca?.logo_url || '',
    foto_url: marca?.foto_url || '',
    horario_lunes: marca?.horario_lunes || '',
    horario_martes: marca?.horario_martes || '',
    horario_miercoles: marca?.horario_miercoles || '',
    horario_jueves: marca?.horario_jueves || '',
    horario_viernes: marca?.horario_viernes || '',
    horario_sabado: marca?.horario_sabado || '',
    horario_domingo: marca?.horario_domingo || '',
    publicado: marca?.publicado !== undefined ? marca.publicado : true,
    // SEO fields
    seo_title: marca?.seo_title || '',
    seo_description: marca?.seo_description || '',
    og_image_url: marca?.og_image_url || '',
    robots_index: marca?.robots_index !== undefined ? marca.robots_index : true,
    json_ld: marca?.json_ld || '',
    // Alt text fields
    logo_alt_text: marca?.logo_alt_text || '',
    foto_alt_text: marca?.foto_alt_text || '',
  })
  const [descuentos, setDescuentos] = useState([])
  const [newDescuento, setNewDescuento] = useState({
    titulo: '',
    descripcion: '',
    tipo_descuento: 'porcentaje',
    porcentaje: '',
    monto_descuento: '',
    fecha_inicio: '',
    fecha_fin: '',
    activo: true
  })
  const [submitting, setSubmitting] = useState(false)
  const [loadingDescuentos, setLoadingDescuentos] = useState(false)
  const [logoFile, setLogoFile] = useState(null)
  const [logoPreview, setLogoPreview] = useState(marca?.logo_url || '')
  const [fotoFile, setFotoFile] = useState(null)
  const [fotoPreview, setFotoPreview] = useState(marca?.foto_url || '')
  const [fotos, setFotos] = useState([])
  const [loadingFotos, setLoadingFotos] = useState(false)
  const [selectedFotoFile, setSelectedFotoFile] = useState(null)
  const [selectedFotoPreview, setSelectedFotoPreview] = useState('')
  const [mostrarFotos, setMostrarFotos] = useState(true)

  const handleLogoChange = (e) => {
    const file = e.target.files?.[0]
    if (!file) {
      setLogoFile(null)
      setLogoPreview('')
      return
    }
    setLogoFile(file)
    const previewUrl = URL.createObjectURL(file)
    setLogoPreview(previewUrl)
  }

  const handleFotoChange = (e) => {
    const file = e.target.files?.[0]
    if (!file) {
      setFotoFile(null)
      setFotoPreview('')
      return
    }
    setFotoFile(file)
    const previewUrl = URL.createObjectURL(file)
    setFotoPreview(previewUrl)
  }

  // Load descuentos if editing existing marca
  useEffect(() => {
    if (marca?.id) {
      fetchDescuentos()
      fetchFotos()
    }
  }, [marca])

  const fetchDescuentos = async () => {
    if (!marca?.id) return
    setLoadingDescuentos(true)
    try {
      const { data } = await supabase
        .from('descuentos_tiendas')
        .select('*')
        .eq('tienda_id', marca.id)
        .order('created_at', { ascending: false })
      setDescuentos(data || [])
    } catch (error) {
      console.error('Error loading descuentos:', error)
    } finally {
      setLoadingDescuentos(false)
    }
  }

  const fetchFotos = async () => {
    if (!marca?.id) return
    setLoadingFotos(true)
    try {
      const { data } = await supabase
        .from('tiendas_fotos')
        .select('*')
        .eq('tienda_id', marca.id)
        .order('orden', { ascending: true })
      setFotos(data || [])
      // Set mostrarFotos based on if there are any active photos
      setMostrarFotos(data && data.some(f => f.activo))
    } catch (error) {
      console.error('Error loading fotos:', error)
    } finally {
      setLoadingFotos(false)
    }
  }

  const handleAddDescuento = async () => {
    if (!newDescuento.titulo.trim()) {
      alert('El título del descuento es obligatorio')
      return
    }

    if (!marca?.id) {
      alert('Primero debes guardar la tienda antes de agregar descuentos')
      return
    }

    try {
      const descuentoData = {
        tienda_id: marca.id,
        titulo: newDescuento.titulo,
        descripcion: newDescuento.descripcion,
        tipo_descuento: newDescuento.tipo_descuento,
        porcentaje: newDescuento.tipo_descuento === 'porcentaje' ? parseInt(newDescuento.porcentaje) || null : null,
        monto_descuento: newDescuento.tipo_descuento === 'monto' ? parseFloat(newDescuento.monto_descuento) || null : null,
        fecha_inicio: newDescuento.fecha_inicio || null,
        fecha_fin: newDescuento.fecha_fin || null,
        activo: newDescuento.activo
      }

      const { error } = await supabase
        .from('descuentos_tiendas')
        .insert([descuentoData])

      if (error) throw error

      alert('Descuento agregado exitosamente')
      setNewDescuento({
        titulo: '',
        descripcion: '',
        tipo_descuento: 'porcentaje',
        porcentaje: '',
        monto_descuento: '',
        fecha_inicio: '',
        fecha_fin: '',
        activo: true
      })
      fetchDescuentos()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al agregar descuento')
    }
  }

  const handleDeleteDescuento = async (descuentoId) => {
    if (!confirm('¿Estás seguro de eliminar este descuento?')) return

    try {
      const { error } = await supabase
        .from('descuentos_tiendas')
        .delete()
        .eq('id', descuentoId)

      if (error) throw error

      alert('Descuento eliminado')
      fetchDescuentos()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al eliminar descuento')
    }
  }

  const toggleDescuentoActivo = async (descuentoId, currentState) => {
    try {
      const { error } = await supabase
        .from('descuentos_tiendas')
        .update({ activo: !currentState })
        .eq('id', descuentoId)

      if (error) throw error
      fetchDescuentos()
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const handleFotoFileChange = (e) => {
    const file = e.target.files?.[0]
    if (!file) {
      setSelectedFotoFile(null)
      setSelectedFotoPreview('')
      return
    }
    setSelectedFotoFile(file)
    const previewUrl = URL.createObjectURL(file)
    setSelectedFotoPreview(previewUrl)
  }

  const handleAddFoto = async () => {
    if (!selectedFotoFile) {
      alert('Por favor selecciona una imagen')
      return
    }

    if (!marca?.id) {
      alert('Primero debes guardar la tienda antes de agregar fotos')
      return
    }

    try {
      // Upload image to storage
      const safeName = selectedFotoFile.name.replace(/\s+/g, '_')
      const path = `tiendas/fotos/${Date.now()}_${safeName}`
      const { error: uploadError } = await storage.uploadImage('assets', selectedFotoFile, path)
      if (uploadError) throw uploadError
      const publicUrl = storage.getPublicUrl('assets', path)

      // Get next order number
      const maxOrden = fotos.length > 0 ? Math.max(...fotos.map(f => f.orden)) : -1

      // Insert into database
      const { error } = await supabase
        .from('tiendas_fotos')
        .insert([{
          tienda_id: marca.id,
          imagen_url: publicUrl,
          orden: maxOrden + 1,
          activo: true
        }])

      if (error) throw error

      alert('Foto agregada exitosamente')
      setSelectedFotoFile(null)
      setSelectedFotoPreview('')
      fetchFotos()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al agregar foto')
    }
  }

  const handleDeleteFoto = async (fotoId) => {
    if (!confirm('¿Estás seguro de eliminar esta foto?')) return

    try {
      const { error } = await supabase
        .from('tiendas_fotos')
        .delete()
        .eq('id', fotoId)

      if (error) throw error

      alert('Foto eliminada')
      fetchFotos()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al eliminar foto')
    }
  }

  const toggleFotoActivo = async (fotoId, currentState) => {
    try {
      const { error } = await supabase
        .from('tiendas_fotos')
        .update({ activo: !currentState })
        .eq('id', fotoId)

      if (error) throw error
      fetchFotos()
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)

    try {
      // Clean up form data - convert empty strings to null for UUID fields
      const cleanedData = {
        ...formData,
        categoria_id: formData.categoria_id || null
      }

      // Upload logo if a new file was selected
      if (logoFile) {
        const safeName = logoFile.name.replace(/\s+/g, '_')
        const path = `tiendas/logos/${Date.now()}_${safeName}`
        const { error: uploadError } = await storage.uploadImage('assets', logoFile, path)
        if (uploadError) throw uploadError
        const publicUrl = storage.getPublicUrl('assets', path)
        cleanedData.logo_url = publicUrl
      }

      // Upload foto if a new file was selected
      if (fotoFile) {
        const safeName = fotoFile.name.replace(/\s+/g, '_')
        const path = `tiendas/fotos/${Date.now()}_${safeName}`
        const { error: uploadError } = await storage.uploadImage('assets', fotoFile, path)
        if (uploadError) throw uploadError
        const publicUrl = storage.getPublicUrl('assets', path)
        cleanedData.foto_url = publicUrl
      }

      if (marca) {
        // Editar
        const { error } = await supabase
          .from('tiendas')
          .update(cleanedData)
          .eq('id', marca.id)
        if (error) throw error
      } else {
        // Crear
        const { error } = await supabase
          .from('tiendas')
          .insert([cleanedData])
        if (error) throw error
      }
      alert('Marca guardada exitosamente')
      onSuccess()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al guardar la marca')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 overflow-y-auto" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-lg w-full my-8 overflow-hidden" style={{ maxWidth: window.innerWidth < 768 ? '100%' : '896px' }}>
        <div className="p-6 border-b flex justify-between items-center">
          <h2 className="text-2xl font-bold">{marca ? 'Editar' : 'Nueva'} Marca</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl font-bold w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            type="button"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 max-h-[70vh] overflow-y-auto">
          {/* Alert Info */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800">
              <strong>Estado de Publicación:</strong> Las tiendas en "Borrador" solo son visibles en este panel de administración. 
              Marca como "Publicado" cuando esté lista para aparecer en el sitio web público.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Estado de publicación */}
            <div className="md:col-span-2">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={formData.publicado}
                  onChange={(e) => setFormData({...formData, publicado: e.target.checked})}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span className="ml-2 text-sm font-medium">
                  {formData.publicado ? '✅ Publicar en el sitio web' : '📝 Guardar como borrador'}
                </span>
              </label>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Nombre *</label>
              <input
                type="text"
                required
                value={formData.nombre}
                onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Categoría</label>
              <select
                value={formData.categoria_id}
                onChange={(e) => setFormData({...formData, categoria_id: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              >
                <option value="">Seleccionar categoría</option>
                {categorias.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                ))}
              </select>
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Descripción</label>
              <textarea
                rows={3}
                value={formData.descripcion}
                onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Logo de la tienda</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleLogoChange}
                className="w-full px-3 py-2 border rounded-lg"
              />
              {logoPreview && (
                <div className="mt-3">
                  <img
                    src={logoPreview}
                    alt="Vista previa del logo"
                    className="w-32 h-32 object-contain rounded-lg border bg-gray-50 p-2"
                  />
                </div>
              )}
              <p className="text-xs text-gray-500 mt-2">
                📏 Recomendado: 800x800px (proporción 1:1)
              </p>
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Foto referencial de la tienda</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFotoChange}
                className="w-full px-3 py-2 border rounded-lg"
              />
              {fotoPreview && (
                <div className="mt-3">
                  <img
                    src={fotoPreview}
                    alt="Vista previa de la foto"
                    className="w-full h-48 object-cover rounded-lg border"
                  />
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Teléfono</label>
              <input
                type="tel"
                value={formData.telefono}
                onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">WhatsApp</label>
              <input
                type="text"
                value={formData.whatsapp}
                onChange={(e) => setFormData({...formData, whatsapp: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="+51 999 999 999"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">N° Local</label>
              <input
                type="text"
                value={formData.nro_local}
                onChange={(e) => setFormData({...formData, nro_local: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Piso/Planta</label>
              <input
                type="text"
                value={formData.piso_planta}
                onChange={(e) => setFormData({...formData, piso_planta: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            {/* Horarios */}
            <div className="md:col-span-2">
              <h3 className="font-medium mb-3">Horarios de Atención</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'].map(dia => (
                  <div key={dia}>
                    <label className="block text-sm mb-1 capitalize">{dia}</label>
                    <input
                      type="text"
                      value={formData[`horario_${dia}`]}
                      onChange={(e) => setFormData({...formData, [`horario_${dia}`]: e.target.value})}
                      className="w-full px-3 py-2 border rounded-lg text-sm"
                      placeholder="9AM - 6PM"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Sección de Descuentos */}
            {marca && (
              <div className="md:col-span-2 border-t pt-6 mt-4">
                <h3 className="font-bold text-lg mb-4">🏷️ Descuentos y Promociones</h3>
                
                {/* Lista de descuentos existentes */}
                <div className="mb-6">
                  <h4 className="font-medium mb-3 text-sm text-gray-700">Descuentos Actuales</h4>
                  {loadingDescuentos ? (
                    <p className="text-gray-500 text-sm">Cargando descuentos...</p>
                  ) : descuentos.length === 0 ? (
                    <p className="text-gray-500 text-sm bg-gray-50 p-3 rounded">No hay descuentos agregados</p>
                  ) : (
                    <div className="space-y-2">
                      {descuentos.map((desc) => (
                        <div key={desc.id} className="flex items-center justify-between p-3 bg-gray-50 rounded border">
                          <div className="flex-1">
                            <div className="flex items-center gap-2">
                              <span className="font-medium">{desc.titulo}</span>
                              {desc.tipo_descuento === 'porcentaje' && desc.porcentaje && (
                                <span className="px-2 py-0.5 bg-green-100 text-green-800 text-xs font-bold rounded">
                                  {desc.porcentaje}% OFF
                                </span>
                              )}
                              {desc.tipo_descuento === 'monto' && desc.monto_descuento && (
                                <span className="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs font-bold rounded">
                                  S/ {desc.monto_descuento} OFF
                                </span>
                              )}
                              {desc.tipo_descuento === 'promocion' && (
                                <span className="px-2 py-0.5 bg-purple-100 text-purple-800 text-xs font-bold rounded">
                                  PROMOCIÓN
                                </span>
                              )}
                            </div>
                            {desc.descripcion && (
                              <p className="text-sm text-gray-600 mt-1">{desc.descripcion}</p>
                            )}
                            {(desc.fecha_inicio || desc.fecha_fin) && (
                              <p className="text-xs text-gray-500 mt-1">
                                                                {desc.fecha_inicio && `Desde: ${formatLocalDate(desc.fecha_inicio)}`}
                                                                {desc.fecha_fin && ` - Hasta: ${formatLocalDate(desc.fecha_fin)}`}
                              </p>
                            )}
                          </div>
                          <div className="flex items-center gap-2">
                            <button
                              type="button"
                              onClick={() => toggleDescuentoActivo(desc.id, desc.activo)}
                              className={`px-2 py-1 text-xs rounded ${
                                desc.activo ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-600'
                              }`}
                            >
                              {desc.activo ? '✓ Activo' : '× Inactivo'}
                            </button>
                            <button
                              type="button"
                              onClick={() => handleDeleteDescuento(desc.id)}
                              className="px-2 py-1 bg-red-100 text-red-600 rounded text-xs hover:bg-red-200"
                            >
                              🗑️
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Formulario para agregar nuevo descuento */}
                <div className="border-t pt-4">
                  <h4 className="font-medium mb-3 text-sm text-gray-700">Agregar Nuevo Descuento</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div className="md:col-span-2">
                      <label className="block text-xs font-medium mb-1">Título del Descuento *</label>
                      <input
                        type="text"
                        value={newDescuento.titulo}
                        onChange={(e) => setNewDescuento({...newDescuento, titulo: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm"
                        placeholder="Ej: 20% de descuento en toda la tienda"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-xs font-medium mb-1">Descripción</label>
                      <textarea
                        value={newDescuento.descripcion}
                        onChange={(e) => setNewDescuento({...newDescuento, descripcion: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm"
                        rows={2}
                        placeholder="Descripción adicional del descuento"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1">Tipo de Descuento</label>
                      <select
                        value={newDescuento.tipo_descuento}
                        onChange={(e) => setNewDescuento({...newDescuento, tipo_descuento: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm"
                      >
                        <option value="porcentaje">Porcentaje (%)</option>
                        <option value="monto">Monto Fijo (S/)</option>
                        <option value="promocion">Promoción Especial</option>
                      </select>
                    </div>

                    {newDescuento.tipo_descuento === 'porcentaje' && (
                      <div>
                        <label className="block text-xs font-medium mb-1">Porcentaje</label>
                        <input
                          type="number"
                          min="0"
                          max="100"
                          value={newDescuento.porcentaje}
                          onChange={(e) => setNewDescuento({...newDescuento, porcentaje: e.target.value})}
                          className="w-full px-3 py-2 border rounded text-sm"
                          placeholder="20"
                        />
                      </div>
                    )}

                    {newDescuento.tipo_descuento === 'monto' && (
                      <div>
                        <label className="block text-xs font-medium mb-1">Monto (S/)</label>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={newDescuento.monto_descuento}
                          onChange={(e) => setNewDescuento({...newDescuento, monto_descuento: e.target.value})}
                          className="w-full px-3 py-2 border rounded text-sm"
                          placeholder="50.00"
                        />
                      </div>
                    )}

                    <div>
                      <label className="block text-xs font-medium mb-1">Fecha Inicio</label>
                      <input
                        type="date"
                        value={newDescuento.fecha_inicio}
                        onChange={(e) => setNewDescuento({...newDescuento, fecha_inicio: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1">Fecha Fin</label>
                      <input
                        type="date"
                        value={newDescuento.fecha_fin}
                        onChange={(e) => setNewDescuento({...newDescuento, fecha_fin: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={newDescuento.activo}
                          onChange={(e) => setNewDescuento({...newDescuento, activo: e.target.checked})}
                          className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                        />
                        <span className="ml-2 text-xs font-medium">
                          {newDescuento.activo ? '✓ Activar descuento inmediatamente' : 'Crear como inactivo'}
                        </span>
                      </label>
                    </div>

                    <div className="md:col-span-2">
                      <button
                        type="button"
                        onClick={handleAddDescuento}
                        className="w-full px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 text-sm font-medium"
                      >
                        + Agregar Descuento
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Sección SEO */}
            {marca && (
              <div className="md:col-span-2 border-t pt-6 mt-4">
                <h3 className="font-bold text-lg mb-4">🔍 SEO y Meta Tags</h3>
                <p className="text-sm text-gray-600 mb-4">Optimiza cómo aparece esta tienda en Google y redes sociales</p>

                <div className="space-y-4">
                  {/* Alt Text de Imágenes */}
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <h4 className="font-medium mb-3 text-sm">🖼️ Texto Alternativo de Imágenes (Accesibilidad & SEO)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs font-medium mb-1">Alt Text del Logo</label>
                        <input
                          type="text"
                          value={formData.logo_alt_text}
                          onChange={(e) => setFormData({...formData, logo_alt_text: e.target.value})}
                          className="w-full px-3 py-2 border rounded text-sm"
                          placeholder={`Ej: Logo de ${formData.nombre}`}
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium mb-1">Alt Text de la Foto Principal</label>
                        <input
                          type="text"
                          value={formData.foto_alt_text}
                          onChange={(e) => setFormData({...formData, foto_alt_text: e.target.value})}
                          className="w-full px-3 py-2 border rounded text-sm"
                          placeholder={`Ej: Interior de tienda ${formData.nombre}`}
                        />
                      </div>
                    </div>
                  </div>

                  {/* SEO Meta Tags */}
                  <div>
                    <label className="block text-xs font-medium mb-1">
                      Título SEO <span className="text-gray-500">(50-60 caracteres ideal)</span>
                    </label>
                    <input
                      type="text"
                      value={formData.seo_title}
                      onChange={(e) => setFormData({...formData, seo_title: e.target.value})}
                      className="w-full px-3 py-2 border rounded text-sm"
                      placeholder={`${formData.nombre} - Plaza Aurora`}
                      maxLength="70"
                    />
                    <p className="text-xs text-gray-500 mt-1">{formData.seo_title?.length || 0}/70 caracteres</p>
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1">
                      Meta Description <span className="text-gray-500">(150-160 caracteres ideal)</span>
                    </label>
                    <textarea
                      value={formData.seo_description}
                      onChange={(e) => setFormData({...formData, seo_description: e.target.value})}
                      className="w-full px-3 py-2 border rounded text-sm"
                      rows={3}
                      placeholder="Descripción breve que aparecerá en Google y redes sociales"
                      maxLength="160"
                    />
                    <p className="text-xs text-gray-500 mt-1">{formData.seo_description?.length || 0}/160 caracteres</p>
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1">
                      Imagen Open Graph (Redes Sociales) <span className="text-gray-500">(1200x630px recomendado)</span>
                    </label>
                    <input
                      type="url"
                      value={formData.og_image_url}
                      onChange={(e) => setFormData({...formData, og_image_url: e.target.value})}
                      className="w-full px-3 py-2 border rounded text-sm"
                      placeholder="URL completa de la imagen para compartir en redes"
                    />
                    {formData.og_image_url && (
                      <img src={formData.og_image_url} alt="Preview" className="mt-2 w-full max-w-sm h-32 object-cover rounded border" />
                    )}
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1">
                      JSON-LD (Datos Estructurados) <span className="text-gray-500">(Avanzado - Opcional)</span>
                    </label>
                    <textarea
                      value={formData.json_ld}
                      onChange={(e) => setFormData({...formData, json_ld: e.target.value})}
                      className="w-full px-3 py-2 border rounded text-sm font-mono"
                      rows={4}
                      placeholder='{"@type": "Store", "name": "..."}'
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      💡 Dejar vacío para usar valores automáticos
                    </p>
                  </div>

                  <div>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.robots_index}
                        onChange={(e) => setFormData({...formData, robots_index: e.target.checked})}
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      />
                      <span className="ml-2 text-xs font-medium">
                        Permitir que Google indexe esta tienda (Recomendado)
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            )}

            {/* Sección de Fotos de la Tienda */}
            {marca && (
              <div className="md:col-span-2 border-t pt-6 mt-4">
                <h3 className="font-bold text-lg mb-4">📸 Galería de Fotos</h3>
                
                {/* Lista de fotos existentes */}
                <div className="mb-6">
                  <h4 className="font-medium mb-3 text-sm text-gray-700">Fotos Actuales</h4>
                  {loadingFotos ? (
                    <p className="text-gray-500 text-sm">Cargando fotos...</p>
                  ) : fotos.length === 0 ? (
                    <p className="text-gray-500 text-sm bg-gray-50 p-3 rounded">No hay fotos agregadas. Agrega fotos del local, fachada o plano de ubicación.</p>
                  ) : (
                    <div className="space-y-2">
                      {fotos.map((foto) => (
                        <div key={foto.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded border">
                          <img 
                            src={foto.imagen_url} 
                            alt={foto.alt_text || 'Foto de la tienda'}
                            className="w-20 h-20 object-cover rounded"
                          />
                          <div className="flex-1">
                            <p className="text-sm font-medium">Orden: {foto.orden}</p>
                            {foto.alt_text && (
                              <p className="text-xs text-gray-600 mt-1">{foto.alt_text}</p>
                            )}
                          </div>
                          <div className="flex items-center gap-2">
                            <button
                              type="button"
                              onClick={() => toggleFotoActivo(foto.id, foto.activo)}
                              className={`px-2 py-1 text-xs rounded ${
                                foto.activo ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-600'
                              }`}
                            >
                              {foto.activo ? '✓ Visible' : '× Oculta'}
                            </button>
                            <button
                              type="button"
                              onClick={() => handleDeleteFoto(foto.id)}
                              className="px-2 py-1 bg-red-100 text-red-600 rounded text-xs hover:bg-red-200"
                            >
                              🗑️
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Formulario para agregar nueva foto */}
                <div className="border-t pt-4">
                  <h4 className="font-medium mb-3 text-sm text-gray-700">Agregar Nueva Foto</h4>
                  <div className="space-y-3">
                    <div>
                      <label className="block text-xs font-medium mb-1">Seleccionar Imagen</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleFotoFileChange}
                        className="w-full px-3 py-2 border rounded text-sm"
                      />
                      {selectedFotoPreview && (
                        <div className="mt-3">
                          <img
                            src={selectedFotoPreview}
                            alt="Vista previa"
                            className="w-full h-48 object-cover rounded-lg border"
                          />
                        </div>
                      )}
                    </div>

                    <div>
                      <button
                        type="button"
                        onClick={handleAddFoto}
                        disabled={!selectedFotoFile}
                        className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        + Agregar Foto al Slider
                      </button>
                    </div>

                    <div className="bg-blue-50 border border-blue-200 rounded p-3">
                      <p className="text-xs text-blue-800">
                        <strong>Nota:</strong> Las fotos se mostrarán en un slider secundario en la página de detalle de la tienda. 
                        Usa el checkbox "Visible/Oculta" para controlar si se muestran o no en la web pública.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-lg hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
            >
              {submitting ? 'Guardando...' : formData.publicado ? 'Guardar y Publicar' : 'Guardar Borrador'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

// Modal para revisar comentarios
function ComentariosModal({ marca, comentarios, onClose, onApprove }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-lg w-full max-h-[80vh] overflow-hidden" style={{ maxWidth: window.innerWidth < 768 ? '100%' : '672px' }}>
        <div className="p-6 border-b flex justify-between items-center">
          <h2 className="text-2xl font-bold">Comentarios Pendientes - {marca.nombre}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl font-bold w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            type="button"
          >
            ×
          </button>
        </div>
        
        <div className="p-6 overflow-y-auto max-h-96">
          {comentarios.length === 0 ? (
            <p className="text-center text-gray-500 py-8">No hay comentarios pendientes</p>
          ) : (
            <div className="space-y-4">
              {comentarios.map((comentario) => (
                <div key={comentario.id} className="border rounded-lg p-4">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <p className="font-semibold">{comentario.usuario_nombre}</p>
                      <p className="text-sm text-gray-500">{comentario.usuario_email}</p>
                    </div>
                    <span className="text-yellow-500">{'⭐'.repeat(comentario.puntuacion)}</span>
                  </div>
                  <p className="text-gray-700 mb-3">{comentario.comentario}</p>
                  <div className="flex gap-2">
                    <button
                      onClick={() => onApprove(comentario.id, true)}
                      className="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 text-sm"
                    >
                      ✔ Aprobar
                    </button>
                    <button
                      onClick={() => onApprove(comentario.id, false)}
                      className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 text-sm"
                    >
                      ✖ Rechazar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="p-6 border-t">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 border rounded-lg hover:bg-gray-50"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  )
}



